import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDchrZX3dOduRXdPPF1MZqWCabip2ROadY",
  authDomain: "ad-agency-api.firebaseapp.com",
  databaseURL: "https://ad-agency-api-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ad-agency-api",
  storageBucket: "ad-agency-api.firebasestorage.app",
  messagingSenderId: "596766888309",
  appId: "1:596766888309:web:1c8db63dc8f552b730833c",
  measurementId: "G-JCRW9CZ6MQ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;